
// Bootstrap.
require('@/bootstrap');

// Vue.
// window.Vue = require('vue');
import Vue from 'vue/dist/vue.esm.js';
window.Vue = Vue;

// Lib.
Vue.use(require('./lib').default);

// App.
require('./app/main');
